module.exports = __webpack_public_path__ + "img/labor_day_card_img_tablet_v2.d96836e.png";